const MODULE_NAME = 'BubblesModule';

export const GET_TASK_BUBBLES = `${MODULE_NAME}/GET_TASK_BUBBLES`;
export const GET_BUBBLE = `${MODULE_NAME}/GET_BUBBLE`;
export const GET_SYNCHRONIZED_BUBBLES = `${MODULE_NAME}/GET_SYNCHRONIZED_BUBBLES`;
